<template>
  <div class="mdl-card mdl-shadow--2dp">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'card',
  };
</script>



// WEBPACK FOOTER //
// Card.vue?4134edbe